import { FetchFinCategoriesFiltersLifestyleFilters } from '../../../categories/categoriesTypes';
import { FetchLifestylesFilters } from '../../lifestylesTypes';

function transformLifestylesFiltersToFinCategoriesLifestyleFilters(
  lifestylesFilters: FetchLifestylesFilters
): FetchFinCategoriesFiltersLifestyleFilters {
  const lifestyleCategoryId = lifestylesFilters?.lifestyleCategoryId?.in
    ? { in: lifestylesFilters.lifestyleCategoryId.in }
    : undefined;
  const lifestyleParentCategoryId =
    lifestylesFilters?.lifestyleParentCategoryIds
      ? { in: lifestylesFilters.lifestyleParentCategoryIds }
      : undefined;
  const blocked = lifestylesFilters?.blocked;
  const favorite = lifestylesFilters?.favorite;
  const nda = lifestylesFilters?.nda;
  const styleIds = lifestylesFilters?.styleIds;
  const materialIds = lifestylesFilters?.materialIds;
  const lifestyleClientId = lifestylesFilters?.clientIds
    ? { in: lifestylesFilters.clientIds }
    : undefined;
  const gammaId = lifestylesFilters?.gammaId;
  const toneId = lifestylesFilters?.toneId;
  const mainColorId = lifestylesFilters?.mainColorIds
    ? { in: lifestylesFilters.mainColorIds }
    : undefined;
  const authorId = lifestylesFilters?.authorId;

  return {
    lifestyleCategoryId,
    lifestyleParentCategoryId,
    blocked,
    favorite,
    materialIds,
    nda,
    styleIds,
    lifestyleClientId,
    gammaId,
    toneId,
    mainColorId,
    authorId
  };
}

export default transformLifestylesFiltersToFinCategoriesLifestyleFilters;
